export const SOLICITAR_COTACAO_FORM_ID = "solicitar-cotacao-form";

/** Figma 17167:476684 (modal) e 17183:524336 (toast). */
export const SOLICITAR_COTACAO_TITLE = "Solicitar alteração da cotação";
export const SOLICITAR_COTACAO_INTRO = "Você vai solicitar a alteração da cotação desta Obra:";
export const COTACAO_VIGENTE_LABEL = "Cotação vigente";
export const NOVA_COTACAO_LABEL = "Nova cotação";
export const O_QUE_ACONTECE_TITLE = "O que acontece ao solicitar";
export const O_QUE_ACONTECE_TEXTO = (vigente: string) =>
  `A alteração vai para aprovação. Até lá, vale a cotação de ${vigente}.`;
export const CANCELAR_LABEL = "Cancelar";
export const SOLICITAR_LABEL = "Solicitar alteração";
export const SOLICITACAO_ENVIADA_MESSAGE =
  "Solicitação de alteração da cotação enviada para aprovação.";
